module.exports = __webpack_public_path__ + "static/pdf-8bd6509aba6eafe623392995b08c7047.pdf";